import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { formatCurrency } from '../lib/utils';
import { mockServiceOrders, mockVehicles } from '../data/mockData';
import { Wrench, CircleDollarSign, Calendar, Car } from 'lucide-react';
export function Dashboard() {
  const activeOrders = mockServiceOrders.filter(os => os.status !== 'entregue' && os.status !== 'finalizado').length;
  const todayRevenue = mockServiceOrders.filter(os => os.status === 'finalizado' || os.status === 'entregue').reduce((acc, curr) => acc + curr.total, 0); // Simplified for mock
  return <div className="space-y-6" data-id="element-435">
      <div data-id="element-436">
        <h1 className="text-3xl font-heading font-bold tracking-tight" data-id="element-437">
          Dashboard
        </h1>
        <p className="text-muted-foreground mt-1" data-id="element-438">
          Visão geral da sua oficina hoje.
        </p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4" data-id="element-439">
        <Card data-id="element-440">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-441">
            <CardTitle className="text-sm font-medium" data-id="element-442">OS Abertas</CardTitle>
            <Wrench className="h-4 w-4 text-muted-foreground" data-id="element-443" />
          </CardHeader>
          <CardContent data-id="element-444">
            <div className="text-2xl font-bold" data-id="element-445">{activeOrders}</div>
            <p className="text-xs text-muted-foreground" data-id="element-446">+2 desde ontem</p>
          </CardContent>
        </Card>
        <Card data-id="element-447">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-448">
            <CardTitle className="text-sm font-medium" data-id="element-449">
              Faturamento (Hoje)
            </CardTitle>
            <CircleDollarSign className="h-4 w-4 text-muted-foreground" data-id="element-450" />
          </CardHeader>
          <CardContent data-id="element-451">
            <div className="text-2xl font-bold" data-id="element-452">
              {formatCurrency(todayRevenue || 1250)}
            </div>
            <p className="text-xs text-muted-foreground" data-id="element-453">
              +15% em relação a ontem
            </p>
          </CardContent>
        </Card>
        <Card data-id="element-454">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-455">
            <CardTitle className="text-sm font-medium" data-id="element-456">Agendamentos</CardTitle>
            <Calendar className="h-4 w-4 text-muted-foreground" data-id="element-457" />
          </CardHeader>
          <CardContent data-id="element-458">
            <div className="text-2xl font-bold" data-id="element-459">4</div>
            <p className="text-xs text-muted-foreground" data-id="element-460">
              Para os próximos 3 dias
            </p>
          </CardContent>
        </Card>
        <Card data-id="element-461">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2" data-id="element-462">
            <CardTitle className="text-sm font-medium" data-id="element-463">
              Veículos no Pátio
            </CardTitle>
            <Car className="h-4 w-4 text-muted-foreground" data-id="element-464" />
          </CardHeader>
          <CardContent data-id="element-465">
            <div className="text-2xl font-bold" data-id="element-466">{mockVehicles.length}</div>
            <p className="text-xs text-muted-foreground" data-id="element-467">
              Capacidade: 12 vagas
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-7" data-id="element-468">
        <Card className="col-span-4" data-id="element-469">
          <CardHeader data-id="element-470">
            <CardTitle data-id="element-471">Faturamento Recente</CardTitle>
          </CardHeader>
          <CardContent className="pl-2" data-id="element-472">
            <div className="h-[300px] w-full flex items-center justify-center text-muted-foreground border border-dashed rounded-lg" data-id="element-473">
              [Gráfico de Faturamento - Recharts]
            </div>
          </CardContent>
        </Card>
        <Card className="col-span-3" data-id="element-474">
          <CardHeader data-id="element-475">
            <CardTitle data-id="element-476">Próximos Agendamentos</CardTitle>
          </CardHeader>
          <CardContent data-id="element-477">
            <div className="space-y-4" data-id="element-478">
              {[1, 2, 3].map(i => <div key={i} className="flex items-center gap-4" data-id="element-479">
                  <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center" data-id="element-480">
                    <Calendar className="h-5 w-5 text-primary" data-id="element-481" />
                  </div>
                  <div className="flex-1 space-y-1" data-id="element-482">
                    <p className="text-sm font-medium leading-none" data-id="element-483">
                      Troca de Óleo - Honda Civic
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-484">Hoje, 14:00</p>
                  </div>
                  <div className="font-medium text-sm" data-id="element-485">João P.</div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}